import { DOM_IDS, DOM_CLASS_NAMES } from '../utils/constants';

// Used for Loading Icon styling and hiding preferences for initial load
const preLoadStyleRules = [`#${DOM_IDS.subscriptionForm} { display: none; }`, '@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }', `.${DOM_CLASS_NAMES.loading} { display: grid !important; align-content: center; height: 75vh; align-items: center; justify-items: center; }`, `.${DOM_CLASS_NAMES.loading} .${DOM_CLASS_NAMES.uiSpinner} { border: 5px solid #92CFDC; border-radius: 50%; border-top: 5px solid #49A2BA; width: 40px; height: 40px; -webkit-animation: spin 1s linear infinite; animation:spin 1s linear infinite; }`, `.${DOM_CLASS_NAMES.loading} .${DOM_CLASS_NAMES.loadingMessage} { padding: 8px; }`];
export const setPreLoadStyles = () => {
  const preLoadStyle = document.createElement('style');
  preLoadStyle.id = DOM_IDS.preLoadStyle;
  document.head.appendChild(preLoadStyle);
  preLoadStyleRules.forEach((cssRule, index) => {
    if (preLoadStyle && preLoadStyle.sheet) {
      preLoadStyle.sheet.insertRule(cssRule, index);
    }
  });
};
export const resetPreLoadStyles = () => {
  const preLoadStyles = document.querySelectorAll(`[id=${DOM_IDS.preLoadStyle}]`);
  const preLoadStylesLength = preLoadStyles.length;
  for (let i = 0; i < preLoadStylesLength; i++) {
    preLoadStyles[i].remove();
  }
};

// Used for Loading Icon styling for confirmation page
const confirmationPreLoadStyleRules = ['@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }', `.${DOM_CLASS_NAMES.loading} { display: grid !important; align-content: center; align-items: center; justify-items: center; }`, `.${DOM_CLASS_NAMES.loading} .${DOM_CLASS_NAMES.uiSpinner} { border: 5px solid #92CFDC; border-radius: 50%; border-top: 5px solid #49A2BA; width: 40px; height: 40px; -webkit-animation: spin 1s linear infinite; animation:spin 1s linear infinite; }`];
export const setConfirmationPreLoadStyles = () => {
  const preLoadStyle = document.createElement('style');
  preLoadStyle.id = DOM_IDS.preLoadStyle;
  document.head.appendChild(preLoadStyle);
  confirmationPreLoadStyleRules.forEach((cssRule, index) => {
    if (preLoadStyle && preLoadStyle.sheet) {
      preLoadStyle.sheet.insertRule(cssRule, index);
    }
  });
};